import { SEOHead } from '../components/SEOHead';
import { CheckCircle } from 'lucide-react';

export default function AppVerifyUser() {
  return (
    <div className="min-h-screen bg-[var(--color-white)] flex items-center justify-center px-4">
      <SEOHead title="Verifizierung – pixcapture.app" description="E-Mail Verifizierung" path="/app/verify-user" />
      <div className="text-center max-w-md">
        <CheckCircle className="h-16 w-16 text-[var(--color-accent)] mx-auto mb-4" />
        <h1 className="text-[24px] mb-4">E-Mail bestätigen</h1>
        <p className="text-[var(--color-grey)]">
          Wir haben Ihnen einen Bestätigungslink an Ihre E-Mail-Adresse gesendet.
        </p>
      </div>
    </div>
  );
}
